(function () {
  function initMobileNavMustang(drawer) {
    if (!drawer || drawer.dataset.mobileNavMustangInit === 'true') {
      return;
    }

    const pills = Array.from(drawer.querySelectorAll('[data-mobile-nav-pill]'));
    const panels = drawer.querySelectorAll('[data-mobile-nav-panel]');

    if (!pills.length || !panels.length) {
      return;
    }

    drawer.dataset.mobileNavMustangInit = 'true';

    function activatePanel(panelId, focusPill) {
      pills.forEach((pill) => {
        const isActive = pill.getAttribute('data-mobile-nav-pill') === panelId;
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
        pill.setAttribute('tabindex', isActive ? '0' : '-1');

        if (isActive && focusPill) {
          pill.focus({ preventScroll: true });
          pill.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });

      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-mobile-nav-panel') === panelId;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });
    }

    function focusAdjacentPill(currentPill, direction) {
      const currentIndex = pills.indexOf(currentPill);
      if (currentIndex === -1) {
        return;
      }

      const nextIndex = (currentIndex + direction + pills.length) % pills.length;
      const nextPill = pills[nextIndex];
      activatePanel(nextPill.getAttribute('data-mobile-nav-pill'), true);
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', (event) => {
        event.preventDefault();
        activatePanel(pill.getAttribute('data-mobile-nav-pill'), false);
      });

      pill.addEventListener('keydown', (event) => {
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            event.preventDefault();
            focusAdjacentPill(pill, 1);
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            event.preventDefault();
            focusAdjacentPill(pill, -1);
            break;
          case 'Home':
            event.preventDefault();
            activatePanel(pills[0].getAttribute('data-mobile-nav-pill'), true);
            break;
          case 'End':
            event.preventDefault();
            activatePanel(pills[pills.length - 1].getAttribute('data-mobile-nav-pill'), true);
            break;
          default:
            break;
        }
      });
    });

    const activePill = drawer.querySelector('[data-mobile-nav-pill].is-active') || pills[0];
    if (activePill) {
      activatePanel(activePill.getAttribute('data-mobile-nav-pill'), false);
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('#mobile-menu-drawer.drawer--mobile-nav-mustang').forEach(initMobileNavMustang);
  }

  function observeDrawer(drawer) {
    if (!drawer || drawer.dataset.mobileNavMustangObserved === 'true') {
      return;
    }

    drawer.dataset.mobileNavMustangObserved = 'true';

    const observer = new MutationObserver(() => {
      drawer.dataset.mobileNavMustangInit = 'false';
      initMobileNavMustang(drawer);
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  function boot() {
    scan(document);
    document.querySelectorAll('#mobile-menu-drawer.drawer--mobile-nav-mustang').forEach(observeDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
    event.target.querySelectorAll('#mobile-menu-drawer.drawer--mobile-nav-mustang').forEach(observeDrawer);
  });
})();
